"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var BrowserService_1 = require("./BrowserService");
var WebsiteLivenessTracker_1 = require("./WebsiteLivenessTracker");
var axios_1 = require("axios");
var METRIC_POSTING_INTERVAL_IN_MILLI_SEC = 30000;
var LOCAL_STORAGE_KEY_FAILED_METRICS = "WD_MWS_FAILED_METRICS";
var MWS_CLIENT_DIMENSION_REGEXP_STR = "[A-Za-z0-9.:@_/-]";
var MAX_LOG_DELIVERY_ATTEMPT_NUM = 2;
var GB_TOKEN = "gb_access_token";
var GB_EXP = "gb_access_token_exp";
var FORWARD_TOKEN = "mds_token";
var FORWARD_TOKEN_EXPIRATION = "mds_token_expiration";
var FORWARD_TOKEN_AUTH = "mds_authentication";
var FORWARD_BASE_URL = "metrics.amazonworkdocs.com";
var MDS_LOCAL_STOAGE_KEY = "MDS_SWITCH";
var MetricDimensions = (function () {
    function MetricDimensions() {
        this.HostGroup = "ALL";
        this.Host = "ALL";
        this.ServiceName = "AWSGorillaBoyWebsite";
        this.MetricClass = "NONE";
        this.Instance = "NONE";
    }
    return MetricDimensions;
}());
var SimpleMetricEntry = (function () {
    function SimpleMetricEntry() {
    }
    return SimpleMetricEntry;
}());
exports.SimpleMetricEntry = SimpleMetricEntry;
var LatencyMetricEntry = (function (_super) {
    __extends(LatencyMetricEntry, _super);
    function LatencyMetricEntry(MethodName) {
        var _this = _super.call(this) || this;
        _this.MethodName = MethodName;
        _this.MetricName = "Time";
        _this.Unit = "Milliseconds";
        return _this;
    }
    return LatencyMetricEntry;
}(SimpleMetricEntry));
exports.LatencyMetricEntry = LatencyMetricEntry;
var CanonicalMetricEntry = (function () {
    function CanonicalMetricEntry(entry, dataset, marketplace, service, client) {
        this.Dimensions = new MetricDimensions();
        this.MetricName = entry.MetricName;
        this.Unit = entry.Unit;
        this.Values = entry.Values;
        this.Timestamp = new Date().toISOString();
        this.Dimensions.ServiceName = service;
        this.Dimensions.DataSet = dataset;
        this.Dimensions.Marketplace = marketplace;
        this.Dimensions.MethodName = entry.MethodName;
        this.Dimensions.Client = client;
        this.deliverAttemptCount = 0;
    }
    CanonicalMetricEntry.prototype.setDupliate = function (duplicate) {
        this.isDupliate = duplicate;
    };
    return CanonicalMetricEntry;
}());
var MetricService = (function () {
    function MetricService(stage, region, marketplace, service, sessionId, context, logger, forwardingService, userAgent) {
        if (stage === void 0) { stage = "ALPHA"; }
        if (userAgent === void 0) { userAgent = "AWSWorkDocsWebClient"; }
        var _this = this;
        this.stage = stage;
        this.region = region;
        this.marketplace = marketplace;
        this.service = service;
        this.sessionId = sessionId;
        this.context = context;
        this.logger = logger;
        this.forwardingService = forwardingService;
        this.userAgent = userAgent;
        this.isCanary = false;
        this.isAmazonCorpSite = false;
        this.mdsBaseURL = "";
        this.metricEntriesBuffer = [];
        this.parseLocation();
        this.getURL();
        //Memoize the results of sanitizeClientDimensionValue
        this.sanitizeClientDimensionValue = lodash_1.memoize(this.sanitizeClientDimensionValue.bind(this));
        this.websiteLivenessTracker = new WebsiteLivenessTracker_1.default(context);
        context.addEventListener("beforeunload", function () {
            _this.writeMetricsOrLogsToStorage(LOCAL_STORAGE_KEY_FAILED_METRICS, _this.metricEntriesBuffer);
        });
    }
    MetricService.prototype.getLogger = function () {
        return this.logger;
    };
    MetricService.prototype.setSessionId = function (sessionId) {
        this.sessionId = sessionId;
    };
    /**
     * Determining whether a metric is from a canary/non-canary client is determined by the site alias.
     * The list of sites that a canary runs against can be found here https://tiny.amazon.com/pw8cdbu6/codeamazpackAWSWblobmainlib
     *
     * Whenever a new site is added to the file above, the corresponding matching regex should be added into this method
     * for accurate metric reporting.
     */
    MetricService.prototype.parseLocation = function () {
        var sitename = this.context.location.hostname.split(".")[0];
        // Gamma sites
        if (/frisco/.test(sitename) || /nova-migration-demo/.test(sitename)) {
            this.isCanary = true;
        }
        // Prod sites
        if (/workdocs-web-[a-z]+/.test(sitename)) {
            this.isCanary = true;
        }
        if (sitename === "amazon") {
            this.isAmazonCorpSite = true;
        }
    };
    MetricService.prototype.getURL = function () {
        switch (this.stage.toLowerCase()) {
            case "dev":
                this.mdsBaseURL = "https://alpha." + FORWARD_BASE_URL;
                break;
            case "alpha":
                this.mdsBaseURL = "https://alpha." + FORWARD_BASE_URL;
                break;
            case "beta":
            case "gamma":
                this.mdsBaseURL = "https://beta." + FORWARD_BASE_URL;
                break;
            default:
                this.mdsBaseURL = "https://" + this.region + "." + FORWARD_BASE_URL;
        }
    };
    MetricService.prototype.destroy = function () {
        if (this.postDataTimeoutId) {
            clearTimeout(this.postDataTimeoutId);
            this.postDataTimeoutId = null;
        }
    };
    MetricService.prototype.newCounterMetric = function (MethodName, val) {
        this.putMetric({
            MethodName: MethodName,
            MetricName: "Count",
            // We want the value to be 1 only when it's undefined. otherwise, emit the given value
            Values: val === undefined ? 1 : val,
            Unit: "Count",
        });
    };
    /**
     * The MWS endpoint supported value for Client dimension are of the form ^[A-Za-z0-9.:@_/-]+
     * @return Sanitized dimension value
     */
    MetricService.prototype.sanitizeClientDimensionValue = function (client) {
        var regexp = new RegExp(MWS_CLIENT_DIMENSION_REGEXP_STR);
        var allChars = client.split("");
        var sanitizedChars = allChars.map(function (char) {
            if (regexp.test(char)) {
                return char;
            }
            return "_";
        });
        return sanitizedChars.join("");
    };
    MetricService.prototype.putMetric = function (metricEntry) {
        //not a duplicate
        this.metricEntriesBuffer.push(new CanonicalMetricEntry(metricEntry, this.stage, this.marketplace, this.service, this.sanitizeClientDimensionValue(BrowserService_1.default.getOS()) +
            "_" +
            BrowserService_1.default.getOSVersion() +
            "-" +
            this.sanitizeClientDimensionValue(BrowserService_1.default.getBrowser()) +
            "_" +
            BrowserService_1.default.getBrowserVersion()));
        //duplicate entires
        var cannonicalMetricEntry = new CanonicalMetricEntry(metricEntry, this.stage, this.marketplace, this.service, this.sanitizeClientDimensionValue(BrowserService_1.default.getOS()));
        cannonicalMetricEntry.setDupliate(true);
        this.metricEntriesBuffer.push(cannonicalMetricEntry);
        cannonicalMetricEntry = new CanonicalMetricEntry(metricEntry, this.stage, this.marketplace, this.service, this.sanitizeClientDimensionValue(BrowserService_1.default.getBrowser()));
        cannonicalMetricEntry.setDupliate(true);
        this.metricEntriesBuffer.push(cannonicalMetricEntry);
        if (this.isCanary) {
            cannonicalMetricEntry = new CanonicalMetricEntry(metricEntry, this.stage, this.marketplace, this.service, "ALL_CANARY_CLIENTS");
            cannonicalMetricEntry.setDupliate(true);
            this.metricEntriesBuffer.push(cannonicalMetricEntry);
        }
        else {
            cannonicalMetricEntry = new CanonicalMetricEntry(metricEntry, this.stage, this.marketplace, this.service, "ALL_NON_CANARY_CLIENTS");
            cannonicalMetricEntry.setDupliate(true);
            this.metricEntriesBuffer.push(cannonicalMetricEntry);
        }
        if (this.region.toLowerCase() === "us-west-2" &&
            this.stage.toLowerCase() === "prod") {
            if (this.isAmazonCorpSite) {
                cannonicalMetricEntry = new CanonicalMetricEntry(metricEntry, this.stage, this.marketplace, this.service, "ALL_AMAZON_SITE_CLIENTS");
                cannonicalMetricEntry.setDupliate(true);
                this.metricEntriesBuffer.push(cannonicalMetricEntry);
            }
            else {
                cannonicalMetricEntry = new CanonicalMetricEntry(metricEntry, this.stage, this.marketplace, this.service, "ALL_NON_AMAZON_SITE_CLIENTS");
                cannonicalMetricEntry.setDupliate(true);
                this.metricEntriesBuffer.push(cannonicalMetricEntry);
            }
        }
        cannonicalMetricEntry = new CanonicalMetricEntry(metricEntry, this.stage, this.marketplace, this.service, "ALL_CLIENTS");
        cannonicalMetricEntry.setDupliate(true);
        this.metricEntriesBuffer.push(cannonicalMetricEntry);
        this.schedulePostMetrics();
    };
    MetricService.prototype.newLatencyMetric = function (MethodName) {
        var _this = this;
        var performance = this.context.performance;
        var metric = new LatencyMetricEntry(MethodName);
        var startTime = performance.now(), metricObj;
        metricObj = {
            stopAndEmitMetric: function () {
                var endTime = performance.now();
                if (_this.websiteLivenessTracker.getPageVisibilityDuringPeriod(startTime, endTime)) {
                    metric.Values = endTime - startTime;
                    _this.putMetric(metric);
                }
                return metricObj;
            },
        };
        return metricObj;
    };
    MetricService.prototype.newAnonymousLatencyMetric = function () {
        var _this = this;
        var performance = this.context.performance;
        var startTime = performance.now(), metricObj;
        metricObj = {
            emitMetricWithMethodName: function (MethodName) {
                var endTime = performance.now();
                var metric = new LatencyMetricEntry(MethodName);
                if (_this.websiteLivenessTracker.getPageVisibilityDuringPeriod(startTime, endTime)) {
                    metric.Values = endTime - startTime;
                    _this.putMetric(metric);
                }
                return metricObj;
            },
        };
        return metricObj;
    };
    MetricService.prototype.forcePostMetrics = function () {
        var _this = this;
        var localStorage = this.context.localStorage;
        if (this.postDataTimeoutId) {
            clearTimeout(this.postDataTimeoutId);
            var ret = this.postMetricsAndLogs();
            ret.catch(function () {
                try {
                    localStorage.setItem(LOCAL_STORAGE_KEY_FAILED_METRICS, JSON.stringify(_this.metricEntriesBuffer));
                }
                catch (e) {
                    localStorage.removeItem(LOCAL_STORAGE_KEY_FAILED_METRICS);
                    //some times console.log is complemented, so log the message afterwards
                    console.log("Encountered error while setting failed metrics in LocalStorage");
                }
            });
            return ret;
        }
        return Promise.resolve({});
    };
    MetricService.prototype.schedulePostMetrics = function () {
        if (!this.postDataTimeoutId) {
            // @ts-ignore // Need to type cast Timer.
            this.postDataTimeoutId = setTimeout(this.postMetricsAndLogs.bind(this), METRIC_POSTING_INTERVAL_IN_MILLI_SEC);
        }
    };
    MetricService.prototype.postMetricsAndLogs = function () {
        var _this = this;
        var localStorage = this.context.localStorage;
        var metricDeliveryServiceSwitch = localStorage.getItem(MDS_LOCAL_STOAGE_KEY) === "true";
        this.postDataTimeoutId = null;
        // If there is a pending delivery pormise, yield and try later
        if (this.postMetricsAndLogsPromise) {
            this.schedulePostMetrics();
        }
        else {
            this.postMetricsAndLogsPromise = Promise.all([
                this.forwardMetrics(),
                this.postLogs(),
            ]);
            this.metricEntriesBuffer = []; //reset the data buffer
            this.postMetricsAndLogsPromise.then(function () {
                _this.postMetricsAndLogsPromise = null;
            }, function () {
                _this.postMetricsAndLogsPromise = null;
            });
        }
        return this.postMetricsAndLogsPromise;
    };
    MetricService.prototype.getExistingMetricsOrLogsFromStorage = function (localStorageKey) {
        var localStorage = this.context.localStorage;
        var existingEntriesString = localStorage.getItem(localStorageKey);
        var existingEntries = [];
        if (existingEntriesString) {
            try {
                existingEntries = JSON.parse(existingEntriesString);
            }
            catch (e) {
                console.log("error parsing metric log entries");
            }
        }
        return existingEntries;
    };
    MetricService.prototype.writeMetricsOrLogsToStorage = function (localStorageKey, metricEntries) {
        // cap the record to 2500 (~1.5mb). for details: https://www.html5rocks.com/en/tutorials/offline/quota-research/
        var localStorage = this.context.localStorage;
        var existingEntries = this.getExistingMetricsOrLogsFromStorage(localStorageKey);
        var newEntries = existingEntries.concat(metricEntries);
        if (newEntries.length > 2500) {
            newEntries = lodash_1.drop(newEntries, newEntries.length - 2500);
        }
        try {
            localStorage.setItem(localStorageKey, JSON.stringify(newEntries));
        }
        catch (e) {
            localStorage.removeItem(localStorageKey);
            console.log("Error writing metrics to local storage");
        }
    };
    MetricService.prototype.postLogs = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var allLogs;
            return __generator(this, function (_a) {
                allLogs = this.metricEntriesBuffer.filter(function (entry) { return !entry.isDupliate; });
                if (!!this.logger) {
                    allLogs.forEach(function (record) {
                        var logRecord = {
                            Event: _this.service + "_MetricMethodName_" + record.Dimensions.MethodName,
                        };
                        if (record.MetricName === "Time") {
                            logRecord.Latency = record.Values;
                        }
                        else {
                            logRecord.Metadata = record.Values.toString();
                        }
                        _this.logger.log(logRecord);
                    });
                    return [2 /*return*/, this.logger.forcePostLogs()];
                }
                return [2 /*return*/];
            });
        });
    };
    MetricService.prototype.forwardMetrics = function () {
        return __awaiter(this, void 0, void 0, function () {
            var localStorage, metricEntriesToSend, metricsBatches, config, gbToken, gbExpiration, response, failedMetrics, _i, metricEntriesToSend_1, entry;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        localStorage = this.context.localStorage;
                        metricEntriesToSend = this.metricEntriesBuffer.concat(this.getExistingMetricsOrLogsFromStorage(LOCAL_STORAGE_KEY_FAILED_METRICS));
                        localStorage.removeItem(LOCAL_STORAGE_KEY_FAILED_METRICS);
                        metricsBatches = lodash_1.chunk(metricEntriesToSend, 500);
                        if (!this.forwardPostReady()) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.forwardPostRequest(metricsBatches)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 2:
                        config = void 0;
                        if (this.stage.toLowerCase() === "prod") {
                            gbToken = localStorage.getItem(GB_TOKEN);
                            gbExpiration = localStorage.getItem(GB_EXP);
                            config = {
                                headers: {
                                    "x-amz-security-token": gbToken && new Date(gbExpiration) > new Date() ? gbToken : null,
                                    "x-amz-user-agent": this.userAgent,
                                },
                            };
                        }
                        else {
                            config = {
                                headers: {
                                    "x-amz-security-token": null,
                                    "x-amz-user-agent": this.userAgent,
                                },
                            };
                        }
                        return [4 /*yield*/, axios_1.default.get(this.mdsBaseURL + "/api/v1/token", config)];
                    case 3:
                        response = _a.sent();
                        if (!(response.status === 200)) return [3 /*break*/, 5];
                        localStorage.setItem(FORWARD_TOKEN, response.data.Token);
                        localStorage.setItem(FORWARD_TOKEN_EXPIRATION, response.data.TokenExpirationUtc);
                        localStorage.setItem(FORWARD_TOKEN_AUTH, String(!!localStorage.getItem(GB_TOKEN)));
                        return [4 /*yield*/, this.forwardPostRequest(metricsBatches)];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        failedMetrics = [];
                        for (_i = 0, metricEntriesToSend_1 = metricEntriesToSend; _i < metricEntriesToSend_1.length; _i++) {
                            entry = metricEntriesToSend_1[_i];
                            entry.deliverAttemptCount++;
                            failedMetrics.push(entry);
                        }
                        this.errorMetricHelper(failedMetrics);
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    MetricService.prototype.forwardPostReady = function () {
        var localStorage = this.context.localStorage;
        var fsExpiration = localStorage.getItem(FORWARD_TOKEN_EXPIRATION);
        var fsToken = localStorage.getItem(FORWARD_TOKEN);
        var gbToken = localStorage.getItem(GB_TOKEN);
        var fsAuth = localStorage.getItem(FORWARD_TOKEN_AUTH);
        if (fsAuth === "true" && !!fsToken && new Date() < new Date(fsExpiration)) {
            return true;
        }
        else if (!gbToken && !!fsToken && new Date() < new Date(fsExpiration)) {
            return true;
        }
        else {
            return false;
        }
    };
    MetricService.prototype.forwardPostRequest = function (_metricsBatches) {
        return __awaiter(this, void 0, void 0, function () {
            var failedMetrics, localStorage, _i, _metricsBatches_1, batch, request, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        failedMetrics = [];
                        localStorage = this.context.localStorage;
                        _i = 0, _metricsBatches_1 = _metricsBatches;
                        _a.label = 1;
                    case 1:
                        if (!(_i < _metricsBatches_1.length)) return [3 /*break*/, 6];
                        batch = _metricsBatches_1[_i];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        request = {
                            metrics: batch.map(function (entry) {
                                var metricDTO = Object.assign({}, entry);
                                // IMPORTANT: must remove these two failed. otherwise kinesis will fail due to not recognize these fields.
                                delete metricDTO.isDupliate;
                                delete metricDTO.deliverAttemptCount;
                                return metricDTO;
                            }),
                            host: this.sessionId,
                            version: "1.0",
                            region: this.region,
                        };
                        return [4 /*yield*/, axios_1.default.post(this.mdsBaseURL + "/api/v1/metrics", JSON.stringify(request), {
                                headers: {
                                    "x-amz-security-token": localStorage.getItem(FORWARD_TOKEN),
                                    "x-amz-user-agent": this.userAgent,
                                },
                            })];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 4:
                        error_1 = _a.sent();
                        batch.forEach(function (entry) {
                            entry.deliverAttemptCount++;
                            failedMetrics.push(entry);
                        });
                        return [3 /*break*/, 5];
                    case 5:
                        _i++;
                        return [3 /*break*/, 1];
                    case 6:
                        this.errorMetricHelper(failedMetrics);
                        return [2 /*return*/];
                }
            });
        });
    };
    MetricService.prototype.errorMetricHelper = function (_failedMetrics) {
        var discardedMetrics = [];
        var retriableMetrics = [];
        _a = lodash_1.partition(_failedMetrics, function (entry) {
            return entry.deliverAttemptCount < MAX_LOG_DELIVERY_ATTEMPT_NUM;
        }), retriableMetrics = _a[0], discardedMetrics = _a[1];
        // log the count of discarded logs
        if (discardedMetrics.length > 0) {
            this.putMetric({
                MethodName: "metricsDeliveryFailure",
                MetricName: "Count",
                Values: discardedMetrics.length,
                Unit: "Count",
            });
        }
        // Clear the localstorage and buffer
        this.context.localStorage.removeItem(LOCAL_STORAGE_KEY_FAILED_METRICS);
        if (retriableMetrics.length > 0 || discardedMetrics.length > 0) {
            this.writeMetricsOrLogsToStorage(LOCAL_STORAGE_KEY_FAILED_METRICS, retriableMetrics);
            return "SUCCEEDED_WITH_ERROR";
        }
        else {
            return "SUCCEEDED";
        }
        var _a;
    };
    return MetricService;
}());
exports.default = MetricService;
